const CACHE_PREFIX = "colega-link-";


export async function unregisterServiceWorkers() {
  if (!("serviceWorker" in navigator)) return 0;

  const registrations = await navigator.serviceWorker.getRegistrations();
  const results = await Promise.all(
    registrations.map((registration) => registration.unregister())
  );

  if ("caches" in window) {
    const keys = await window.caches.keys();
    await Promise.all(
      keys
        .filter((key) => key.startsWith(CACHE_PREFIX))
        .map((key) => window.caches.delete(key))
    );
  }

  return results.filter(Boolean).length;
}